import React from 'react';
import { AuthCallback } from '@/components/AuthCallback';

const AuthCallbackPage = () => {
  return <AuthCallback />;
};

export default AuthCallbackPage;